<template>
    <CampaignCouponForm />
</template>

<script>
import CampaignCouponForm from "@/components/CampaignCouponForm.vue";

export default {
    name: "CampaignCouponFormView",
    components: {
        CampaignCouponForm,
    },
};
</script>